import React from 'react';
import PropTypes from 'prop-types';
import i18n from '../../../i18n';
import { LeftIcon } from '@wix/wix-vod-shared/icons';
import { logSharedBi } from '../../../bi';
import styles from './styles.scss';
import { fedopsInteractions } from '../../../services/fedops-logger';

const ERROR_TYPE = 'Video is not available';

class Error extends React.Component {
  static propTypes = {
    siteUrl: PropTypes.string,
  };

  componentDidMount() {
    logSharedBi('widget.vid.error', {
      errorType: ERROR_TYPE,
    });

    fedopsInteractions.errorStateShown();
  }

  render() {
    const { siteUrl } = this.props;

    return (
      <div className={styles.error} tabIndex="0">
        <div>
          <h1>{i18n.t('error.title')}</h1>
        </div>
        <div>
          <a
            href={siteUrl}
            rel="noopener noreferrer"
            tabIndex="0"
            target="_blank"
          >
            {i18n.t('error.go-to-site')}
          </a>
          <LeftIcon className={styles.arrow} />
        </div>
      </div>
    );
  }
}

export default Error;
